import React from 'react';

// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import Draggable from 'react-draggable';
// import Paper from '@material-ui/core/Paper';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { useHistory } from "react-router-dom";

// import CustomSearchInputMultiple from '../custom/searchinputmultiple';
// import CustomSelect from '../custom/select';
import { PAGINATION } from '../../constants';
import API from '../../services/api';
import ButtonSort from '../custom/buttonsort';
import CustomAlert from '../custom/alert';
import CustomPaper from '../custom/paper';
// import CustomSearchInput from '../custom/searchinput';
import CustomSearchAutoComplete from '../custom/searchautocomplete';
import CustomTablePagination from '../custom/tablepagination';
import DraggableDialog from '../draggabledialog';
import Subtitle from '../subtitle';
import { PAGE_ROUTE } from '../../constants';
import Title from '../title';

export default function Schools({ children, ...props }) {
  const history = useHistory();
  const load = React.useRef(true);
  // const [filter, setFilter] = React.useState('');
  const [addableName, setAddableName] = React.useState('');
  const [addableShow, setAddableShow] = React.useState(false);
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [editableItem, setEditableItem] = React.useState({ id: -1, name: '' });
  const [open, setOpen] = React.useState(false);
  const [pagination, setPagination] = React.useState({ perPage: PAGINATION.PER_PAGE });
  const [query, setQuery] = React.useState({});
  const [reload, setReload] = React.useState(false);
  const [removableItem, setRemovableItem] = React.useState({ id: -1, name: '' });
  const [sortConfig, setSortConfig] = React.useState({ asc: true, id: '' });
  const [state, setState] = React.useState({ data: [], lastPage: 1, page: 1, perPage: 20, total: 0 });

  function componentDidMount() {
    if (load.current) {
      API.Schools.index({ ...pagination, ...query }).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onPaginationChanged() {
    API.Schools.index({ ...pagination, ...query }).then(onSuccess).catch(onFailure);
    return function paginationChanged() { };
  }

  function onReloadChanged() {
    if (reload) {
      API.Schools.index({ ...query, perPage: pagination.perPage, page: 1 }).then(onSuccess).catch(onFailure);
      // setData(data.filter((item) => item.id !== response.data.id));
    }
    return function reloadChanged() { setReload(false); };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onPaginationChanged, [pagination]);
  React.useEffect(onReloadChanged, [reload]);

  function onSuccess(response) {
    if (load.current && response.data) {
      const collator = new Intl.Collator('pt-br', { numeric: true, sensitivity: 'base' });
      setState({ ...response.data, data: response.data.data.sort((a, b) => collator.compare(a.name, b.name)) });
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  function handleEditableCancel() {
    setEditableItem({ id: -1, name: '' });
  }

  function handleAddableCancel() {
    setAddableName('');
    setAddableShow(false);
  }

  function handleAddableClick(event) {
    event.preventDefault();
    setAddableShow(!addableShow);
    handleEditableCancel();
  }

  function handleAddableStore() {
    if (addableName) {
      API.Schools.store({ name: addableName, bank_id: 1 })
        .then(() => {
          setReload(true);
        })
        .catch((error) => {
          setAlert({ open: true, message: error.message });
        });
    }
    handleAddableCancel();
  }

  function handleAddableOnChange(event) {
    event.preventDefault();
    setAddableName(event.target.value);
  }

  function handleEditableOnChange(event) {
    event.preventDefault();
    setEditableItem({ ...editableItem, name: event.target.value });
  }

  function handleEditableUpdate() {
    if (editableItem.name) {
      API.Schools.update(editableItem.id, { name: editableItem.name })
        .then(() => {
          setReload(true);
        })
        .catch((error) => {
          setAlert({ open: true, message: error.message });
        });
    }
    handleEditableCancel();
  }

  function handleAddableKeyDown(event) {
    // Esc = 27
    if (event.which === 27) {
      event.preventDefault();
      handleAddableCancel();
    }
    // Enter = 13
    else if (event.which === 13) {
      event.preventDefault();
      handleAddableStore();
    }
  }

  function handleEditableKeyDown(event) {
    // Esc = 27
    if (event.which === 27) {
      event.preventDefault();
      handleEditableCancel();
    }
    // Enter = 13
    else if (event.which === 13) {
      event.preventDefault();
      handleEditableUpdate();
    }
  }

  function handleEditableClick(event, id) {
    event.preventDefault();
    editableItem.id === id ? handleEditableUpdate() : setEditableItem({ ...editableItem, id: id });
    handleAddableCancel();
  }

  function handleEditableDeleteClick(event, item) {
    event.preventDefault();
    handleAddableCancel();
    setRemovableItem(item);
    setOpen(true);
  }

  const handleAddClick = (id) => (event) => {
    event.preventDefault();
    if (id) {
      history.push(`${PAGE_ROUTE.SERIES}/${id}`);
    }
  }

  function handleConfirm() {
    API.Schools.destroy(removableItem.id)
      .then(() => {
        setReload(true);
      })
      .catch((error) => {
        setAlert({ open: true, message: error.message });
      });
    handleClose();
  }

  /*
  const PaperComponent = React.forwardRef((props, ref) => (
    <Draggable ref={ref} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  ));

  const PersistentDialog = React.forwardRef((props, ref) => (
    <Dialog
      variant="persistent"
      open={props.open}
      ref={ref}
      onClose={handleClose}
      // PaperComponent={PaperComponent}
      // PaperComponent={{ component: PaperComponent, nodeRef: nodeRef }}
      PaperProps={{ component: PaperComponent, ...props, ref }}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Remover agência</DialogTitle>
      <DialogContent>
        <DialogContentText>{`A remoção não pode ser desfeita, deseja confirmar a remoção da agência '${nameToRemove}'?`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">Não</Button>
        <Button onClick={handleConfirm} color="primary">Sim</Button>
      </DialogActions>
    </Dialog>
  )
  );
  */

  //function handleSearchClear(event) {
  //  event.preventDefault();
  //  delete query.school_name;
  //  setReload(true);
  //}

  //function handleSearchSubmit(event) {
  //  event.preventDefault();
  //  setReload(true);
  //}

  function handleChangePagination(newPagination) {
    setPagination({ ...pagination, ...newPagination });
  }

  return (
    <CustomPaper>
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })} >{alert.message}</CustomAlert>
      <Grid container spacing={1}>
        <Grid item >
          <Title><AccountBalanceIcon /></Title>
        </Grid>

        <Grid item >
          <Title>Agências</Title>
        </Grid>

        <Grid item xs >
          <IconButton size="medium" onClick={handleAddableClick}>{!addableShow && <AddCircleIcon />}</IconButton>
        </Grid>

        {/* <Grid item >
          <CustomSearchInputMultiple fetch={API.Users.index} value={''} label={'Buscar cliente'} placeholder={'Buscar cliente'} onChange={handleOnChange} />
        </Grid> */}

        <Grid item xs>

          {/* <CustomSelect
            title={'Agência'}
            first={'Selecione uma agência'}
            // value={state.school_id || null}
            // helperText={validate.school_id ? validate.school_id : ''}
            // error={validate.school_id ? true : false}
            // onFocus={() => setValidate({ ...validate, school_id: null })}
            // onKeyDown={handleKeyDown}
            // onChange={(event) => setState({ ...state, school_id: event.target.value })}
            fetch={API.Schools.index}
          /> */}

          {/* <CustomSearchInputMultiple fetch={API.Schools.index} value={''} placeholder={'Buscar agência'} onChange={handleOnChange} /> */}
          <CustomSearchAutoComplete
            reload={reload}
            onChange={(value) => { setQuery({ ...query, school_name: value }); setReload(true); }}
            placeholder={'Buscar agência por nome'}
            fetch={API.Schools.index}
            value={query.user_name}
          />
        </Grid>

      </Grid>

      {/* <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Remoção"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {"A remoção não pode ser desfeita, deseja confirmar a remoção da agência '" + nameToRemove + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* <PersistentDialog
        ref={ref}
        open={open}
      >
      </PersistentDialog> */}

      <DraggableDialog
        open={open}
        onCancel={handleClose}
        onConfirm={handleConfirm}
        title="Remoção de agência"
        body={"A remoção não pode ser desfeita, deseja confirmar a remoção da agência '" + removableItem.name + "'?"}
      />

      <Table size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell align="left"></TableCell> */}
            {/* <TableCell align="left"><Subtitle>Data de criação</Subtitle></TableCell> */}
            <TableCell align="left">
              <ButtonSort
                id={'name'}
                keys={['name']}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Agência'}
              </ButtonSort>
            </TableCell>
            <TableCell align="left"><Subtitle>{'Editar'}</Subtitle></TableCell>
            <TableCell align="left"><Subtitle>{'Série'}</Subtitle></TableCell>
            <TableCell align="left"><Subtitle>{'Remover'}</Subtitle></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {addableShow && (
            <TableRow>
              <TableCell>
                <TextField
                  required={true}
                  fullWidth={true}
                  id={"addable-input"}
                  defaultValue={addableName}
                  label="Adicione o nome da agência"
                  onChange={handleAddableOnChange}
                  onKeyDown={handleAddableKeyDown}
                  color="primary"
                  InputProps={{
                    disableUnderline: false,
                    readOnly: false,
                    autoFocus: true,
                  }}
                />
              </TableCell>
              <TableCell>
                <IconButton size="small" onClick={handleAddableStore}>
                  <DoneIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          )}
          {state.data
            // .filter(item => { return item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 })
            .map((item, index) => (
              <TableRow key={item.id}>
                {/* <TableCell>{index + 1}</TableCell> */}
                {/* <TableCell>{item.id}</TableCell> */}
                {/* <TableCell>{new Date(item.created_at).toLocaleString("pt-BR")}</TableCell> */}
                <TableCell align="left">
                  {editableItem.id === item.id ? (
                    <TextField
                      required={true}
                      fullWidth={true}
                      id="editable-input"
                      defaultValue={item.name}
                      label="Nome da agência"
                      onChange={handleEditableOnChange}
                      onKeyDown={handleEditableKeyDown}
                      color="primary"
                      InputProps={{
                        disableUnderline: false,
                        readOnly: false,
                        autoFocus: true,
                      }}
                    />
                  ) : (item.name)
                  }
                </TableCell>
                <TableCell align="left">
                  <IconButton id={item.id} size="small" onClick={((e) => handleEditableClick(e, item.id))}>
                    {editableItem.id === item.id ? <DoneIcon /> : <EditIcon />}
                  </IconButton>
                </TableCell>
                <TableCell align="left"><IconButton size="small" onClick={handleAddClick(item.id)}><AddCircleIcon /></IconButton></TableCell>
                <TableCell align="left"><IconButton size="small" onClick={((e) => handleEditableDeleteClick(e, item))}><DeleteIcon /></IconButton></TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <CustomTablePagination page={state.page - 1 | 0} count={state.total} onChange={handleChangePagination} />
    </CustomPaper>
  );
}
